<template>
<div class="container home-describe">
  <div class="describe-text">
    <p>放眼全球创新，服务中国增长。</p>
    <p>风物资本是聚焦中国视角，专注跨境创新的早期风险基金。</p>
<!--    <p>关注全球范围内的科技应用与新兴消费的投资机会，于新加坡、上海、东京分别设有办公室。</p>-->
  </div>
  <ul class="describe-list">
    <li v-for="(item, index) in list" :key="index">
      <div class="describe-item" :style="{background:item.background}">
        <div class="item-media">
          <img :src="require(`./images/${item.icon}.png`)" alt="">
        </div>
        <div class="item-content">
          <div class="name">
            {{lang == 'zh' ? item.title : item.enTitle }}
          </div>
          <div v-if="lang == 'zh'" class="describe">{{item.description}}</div>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
import {mapState} from "vuex";
export default {
  name: "HomeDescribe",
  data() {
    return {
      // All in Asia, All in Tech
      // The Global Rise of Chinese Enterprises
      // The Rise of a New Generation
      // Extensive Cross-Border Capabilities and Experiences
      // World-Class Top-Tier Groups Supporting
      // Long-term Companionship
      list: [
        {
          icon:"icon-01",
          title:"All in Asia, All in Tech",
          enTitle:"All in Asia, All in Tech",
          description:"深耕亚洲市场，专注科技创新",
          background:"rgba(246, 237, 240, 1)"
        },
        {
          icon:"icon-02",
          title:"中国企业的全球化崛起",
          enTitle:"The Global Rise of Chinese Enterprises",
          description:"挖掘有潜力成为全球领袖的行业公司",
          background:"rgba(247, 242, 237, 1)"
        },
        {
          icon:"icon-03",
          title:"年轻一代的创业者站上舞台",
          enTitle:"The Rise of a New Generation",
          description:"90后创业者逐渐成为主角，新的思维和方向",
          background:"rgba(239, 246, 249, 1)"
        },
        {
          icon:"icon-04",
          title:"跨境能力决定项目上限",
          enTitle:"Extensive Cross-Border Capabilities and Experiences",
          description:"团队拥有丰富跨境投资经验，实现价值最大化",
          background:"rgba(255, 252, 238, 1)"
        },
        {
          icon:"icon-05",
          title:"世界级的创新公司支持",
          enTitle:"World-Class Top-Tier Groups Supporting",
          description:"全球顶级产业集团给予资本及战略双重赋能",
          background:"rgba(242, 240, 246, 1)"
        },
        {
          icon:"icon-06",
          title:"长期陪伴，并购助力",
          enTitle:"Long-term Companionship and M&A Support",
          description:"践行长期陪伴的承诺，真正的耐心资本",
          background:"rgba(245, 250, 238, 1)"
        }
      ]
    }
  },
  computed:{
    ...mapState(["lang"])
  }
}
</script>

<style scoped lang="scss">
.home-describe{
  padding-top: 56px;
  padding-bottom: 40px;
  width: 1400px;

  .describe-text{
    height: 90px;
    margin-bottom: 10px;
    text-align: center;
    >p{
      font-size: 16px;
      color: #231916;
      line-height: 32px;
    }
  }
  .describe-list{
    display: flex;
    flex-wrap: wrap;
    margin-left: -12px;
    margin-right: -13px;
    >li{
      width: 33.3333%;
      margin-bottom: 20px;
      .describe-item{
        display: flex;
        height: 140px;
        margin-left: 12px;
        margin-right: 13px;
        padding-left: 24px;
        padding-right: 14px;
        align-items: center;
        .item-media{
          width: 60px;
          height: 60px;
          margin-right: 26px;
          >img{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .item-content{
          flex: 1;
          overflow: hidden;
          .name{
            color: rgba(35, 25, 22, 1);
            font-size: 20px;
            margin-bottom: 7px;
            line-height: 32px;
          }
          .describe{
            font-size: 16px;
            color: #231916;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>
